// resources/js/Pages/HallOfFame/utils/pcr.js

export const parsePCR = (pcrList, isVault = false) => {
    if (!pcrList) return { display: '', ratingNumber: 0, tooltip: '' };

    const badges = [];
    let ratingNumber = 0;
    const details = [];
    const hrClass = isVault ? 'hr-effect-vault' : 'hr-effect';

    Object.entries(pcrList).forEach(([reader, data]) => {
        const rating = data.screenplayRating?.substring(0, 3);

        switch (rating) {
            case 'Pas':
                badges.push('P');
                details.push(`${reader}: Pass`);
                break;
            case 'Con':
                badges.push('C');
                ratingNumber += 1;
                details.push(`${reader}: Consider`);
                break;
            case 'Rec':
                badges.push('R');
                ratingNumber += 2;
                details.push(`${reader}: Recommend`);
                break;
            case 'Hig':
                badges.push(`<span class="${hrClass}">HR</span>`);
                ratingNumber += 3;
                details.push(`${reader}: Highly Recommend`);
                break;
        }
    });
    
    return {
        display: badges.join('/'),
        ratingNumber: badges.length > 0 ? ratingNumber / badges.length : 0,
        tooltip: details.join('\n') + '\n\n' + (pcrList[Object.keys(pcrList)[0]]?.executiveSummary || '')
    };
};

/**
 * Mean of the per-reader 0–10 verdict scores in a PCR list.
 *
 * Where the score lives depends on which shape reached the client:
 *   - pcrh_list projected to the legacy shape (pcrListProjected / helpers.php)
 *     flattens verdict_metadata.score to a top-level `score`.
 *   - a raw, unprojected pcrh_list still nests it under verdict_metadata.
 * Both are read here so the column doesn't silently blank out if a caller
 * ever ships the raw list.
 *
 * Older analyses predate the score field entirely and carry only the
 * Pass/Consider/Recommend verdict — those return { value: null } and the
 * column renders blank rather than a misleading 0.
 */
export const parseAvgScore = (pcrList) => {
    if (!pcrList || typeof pcrList !== 'object') {
        return { value: null, count: 0, tooltip: '' };
    }

    const details = [];
    let sum = 0;
    let count = 0;

    Object.entries(pcrList).forEach(([reader, data]) => {
        if (!data || typeof data !== 'object') return;

        const raw = data.score !== undefined && data.score !== null
            ? data.score
            : data.verdict_metadata?.score;

        // Guard against '' / null / 'N/A' — Number('') is 0, which would drag
        // the mean down instead of being excluded.
        if (raw === null || raw === undefined || raw === '') return;
        const num = Number(raw);
        if (!Number.isFinite(num)) return;

        sum += num;
        count += 1;
        details.push(`${reader}: ${num.toFixed(2).replace(/\.?0+$/, '')}`);
    });

    if (count === 0) return { value: null, count: 0, tooltip: '' };

    const value = sum / count;
    return {
        value,
        count,
        tooltip: `Average of ${count} reader score${count === 1 ? '' : 's'} (0–10)\n${details.join('\n')}`
    };
};
